import React, { useState, useEffect } from "react";

const HomePageForm = ({ onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    heading: "",
    para: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <section className="content container-fluid mt-4">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
            <div className="box box-primary">
              <div className="box-header with-border d-flex justify-content-between align-items-center"></div>
              <h3>{initialData ? "Edit" : "Create"} Scrolling Message</h3>
              <div className="mb-3">
                <label htmlFor="heading" className="form-label">
                  Heading
                </label>
                <input
                  type="text"
                  id="heading"
                  className="form-control"
                  value={formData.heading}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="para" className="form-label">
                  Para
                </label>
                <textarea
                  id="para"
                  rows="3"
                  className="form-control"
                  value={formData.para}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-danger me-2">
                {initialData ? "Update" : "Create"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </section>
    </form>
  );
};

export default HomePageForm;
